import type { SVGProps } from 'react';
const SvgUpgrade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#upgrade_svg__a)">
      <path
        fill="currentColor"
        d="M16 18v2H8v-2h8ZM11 7.99V16h2V7.99h3L12 4 8 7.99h3Z"
      />
    </g>
    <defs>
      <clipPath id="upgrade_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUpgrade;
